import { useState } from "react";
import PropTypes from "prop-types";
import { X, LoaderCircle } from "lucide-react";
import SnackbarUtils from "../../../lib/components/Snackbar/utils";

const GetConfigModal = ({ isOpen, onClose, onSubmit }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const availableKeys = ["HeartbeatInterval", "WebSocketPingInterval"];

  const toggleKey = key => {
    setSelectedKeys(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]));
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Get Configuration</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="reset-options">
            {availableKeys.map(key => (
              <label key={key} className="reset-option">
                <input type="checkbox" checked={selectedKeys.includes(key)} onChange={() => toggleKey(key)} />
                <span>{key}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button
            className="btn-submit"
            disabled={isSubmitting}
            onClick={async () => {
              setIsSubmitting(true);
              try {
                await onSubmit(selectedKeys);
                SnackbarUtils.success("Command sent");
                onClose();
              } catch (e) {
                const msg =
                  e?.response?.data?.["error-message"] || e?.response?.data?.message || e?.message || JSON.stringify(e);
                SnackbarUtils.error(msg);
              } finally {
                setIsSubmitting(false);
              }
            }}
          >
            {isSubmitting ? <LoaderCircle className="animate-spin" size={16} /> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

GetConfigModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default GetConfigModal;
